export default function About() {
  return (
    <section 
      id="about" 
      className="py-24 relative"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url('https://static.readdy.ai/image/d89a0480eb41114b9dab96ac9b2db3c5/fa7e9ecb35fd866d7c5c4d7bf4960b62.jpeg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <span className="text-purple-400 font-semibold text-sm uppercase tracking-wider">About Us</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
              Building Digital Excellence Since Day One
            </h2>
            
            <div className="space-y-6 text-lg text-gray-200 leading-relaxed">
              <p>
                DynastyForge was founded with a singular vision: to empower businesses with cutting-edge digital solutions that drive real results. What started as a passion for innovative web design has evolved into a full-service digital agency trusted by hundreds of clients worldwide.
              </p>
              
              <p>
                We specialize in transforming ideas into powerful digital experiences. From stunning Shopify stores and custom web applications to immersive 3D animations and enterprise-grade server infrastructure, we handle every aspect of your digital presence with precision and creativity.
              </p>
              
              <p>
                Our team combines technical expertise with artistic vision, ensuring every project not only looks exceptional but performs flawlessly. We don't just build websites—we craft digital ecosystems that convert visitors into customers and help businesses scale.
              </p>
              
              <p>
                At DynastyForge, we believe in partnerships, not transactions. Your success is our success, and we're committed to delivering solutions that exceed expectations and stand the test of time.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-6">
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl border border-white/20">
                <div className="text-4xl font-bold text-purple-400 mb-2">500+</div>
                <div className="text-white font-medium">Projects Completed</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl border border-white/20">
                <div className="text-4xl font-bold text-purple-400 mb-2">98%</div>
                <div className="text-white font-medium">Client Satisfaction</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl border border-white/20">
                <div className="text-4xl font-bold text-purple-400 mb-2">50+</div>
                <div className="text-white font-medium">Team Members</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md p-6 rounded-2xl border border-white/20">
                <div className="text-4xl font-bold text-purple-400 mb-2">24/7</div>
                <div className="text-white font-medium">Support Available</div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-blue-600 rounded-3xl transform rotate-3"></div>
              <div className="relative bg-white/10 backdrop-blur-md p-8 rounded-3xl shadow-2xl border border-white/20">
                <img 
                  src="https://static.readdy.ai/image/d89a0480eb41114b9dab96ac9b2db3c5/2323f49856dc2756b9fd0d5218f3b31a.png"
                  alt="Founder & CEO of DynastyForge"
                  className="w-full rounded-2xl mb-6"
                />
                
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-white mb-2">
                    Founder & CEO
                  </h3>
                  <p className="text-purple-400 font-semibold mb-4">
                    DynastyForge Digital Agency
                  </p>
                  
                  <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20">
                    <p className="text-gray-200 italic leading-relaxed">
                      "Our mission is simple: transform your vision into digital reality. Every project we undertake is a testament to our commitment to excellence, innovation, and client success."
                    </p>
                  </div>

                  <div className="flex justify-center gap-4 mt-6">
                    <a 
                      href="#contact"
                      className="w-12 h-12 flex items-center justify-center bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-all cursor-pointer"
                    >
                      <i className="ri-linkedin-fill text-xl"></i>
                    </a>
                    <a 
                      href="#contact"
                      className="w-12 h-12 flex items-center justify-center bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-all cursor-pointer"
                    >
                      <i className="ri-twitter-x-fill text-xl"></i>
                    </a>
                    <a 
                      href="#contact"
                      className="w-12 h-12 flex items-center justify-center bg-purple-600 text-white rounded-full hover:bg-purple-700 transition-all cursor-pointer"
                    >
                      <i className="ri-mail-fill text-xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
